import { promise } from '../../../helpers';
import { firebaseUpdateMultipleFiles } from '../firebase';

const saveTeamTaskSubmissionFiles = (item, uploadList) => {
    // eslint-disable-next-line no-unused-vars
    return (dispatch, getState, getFirebase) => {
        // --
        if (uploadList && uploadList.length) {
            return dispatch(firebaseUpdateMultipleFiles({ collection: 'teamTaskSubmissions', docId: item.id, uploadList })).then(
                uploadedFilesData => {
                    if (uploadedFilesData) {
                        return promise({
                            ...item,
                            ...uploadedFilesData,
                        });
                    }

                    return promise(item);
                },
            );
        }

        return promise();
    };
};

export default saveTeamTaskSubmissionFiles;
